import React, { useState } from 'react';
import CashierActionButton from '../../components/CashierActionButton';
import CalculatorModal from './CalculatorModal';

const CashierCalculator = () => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <CashierActionButton
        type='CALCULATOR'
        onClick={() => setVisible(true)}
      />
      <CalculatorModal visible={visible} onClose={() => setVisible(false)} />
    </>
  );
};

export default CashierCalculator;
